/* @flow */
/* eslint-disable babel/no-invalid-this */
import type { ActionButtonsFeature } from "./types";

export default function ActionButtons(feature: ActionButtonsFeature) {
  this.performAction = (action) => {
    return this.executeDeviceAction(action, {}, { fetchModelWhenDone: true });
  };

  return {
    actions: feature.actions,
  };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/action_buttons.js